import { useRecoilState } from "recoil";
import { productKeyAtom } from "src/atoms";

// Mind Sat제품탭 파악
export const useIsMindSatProduct = () => {
  const [productKey] = useRecoilState(productKeyAtom);

  return { isMindSatProduct: productKey === "MIND_SAT" };
};
